/**
 * LDS Swatch — Color swatch behavior for variant picker
 *
 * Handles:
 * - Loading color map JSON and applying hex backgrounds to swatch elements
 * - Selected swatch label update on change
 * - "Show more" pagination (30 initial, +50 per click)
 *
 * Reads configuration from the variant-radios element:
 * - data-color-map-url: URL to the lds-color-map.json asset
 *
 * @requires variant-radios[data-color-map-url]
 */

const INITIAL_VISIBLE = 30;
const LOAD_MORE_COUNT = 500;

document.querySelectorAll('variant-radios[data-color-map-url]').forEach(function (container) {
  /* ─── Update selected label on change ──────────────────────────────── */
  container.addEventListener('change', function (event) {
    const input = event.target.closest('.lds-swatch-input__radio');
    if (!input) return;
    const fieldset = input.closest('fieldset');
    if (!fieldset) return;
    const label = fieldset.querySelector('[data-selected-swatch-value]');
    if (label) label.textContent = input.value;
  });

  /* ─── Load color map and apply backgrounds ─────────────────────────── */
  const colorMapUrl = container.dataset.colorMapUrl;

  if (colorMapUrl) {
    fetch(colorMapUrl)
      .then(function (r) { return r.json(); })
      .then(function (colorMap) {
        container.querySelectorAll('.lds-swatch[data-color-label]').forEach(function (el) {
          const hex = colorMap[el.dataset.colorLabel];
          if (hex) {
            el.style.setProperty('--lds-swatch-bg', hex);
            el.classList.remove('lds-swatch--empty');
          }
        });
      });
  }

  /* ─── Show more / pagination ───────────────────────────────────────── */
  container.querySelectorAll('[data-swatch-fieldset]').forEach(function (fieldset) {
    const grid = fieldset.querySelector('[data-swatch-grid]');
    const btn = fieldset.querySelector('[data-swatch-toggle]');
    if (!grid) return;

    const items = grid.querySelectorAll('.lds-swatch-input');
    var visibleCount = INITIAL_VISIBLE;

    /* Ensure the checked swatch is visible on page load */
    var checkedIndex = Array.prototype.findIndex.call(items, function (item) {
      return item.querySelector('input[type="radio"]:checked');
    });
    if (checkedIndex >= INITIAL_VISIBLE) {
      visibleCount = Math.ceil((checkedIndex + 1) / LOAD_MORE_COUNT) * LOAD_MORE_COUNT;
      if (visibleCount < checkedIndex + 1) visibleCount = checkedIndex + 1;
    }

    function updateVisibility() {
      items.forEach(function (item, i) {
        item.style.display = i < visibleCount ? '' : 'none';
      });
      if (btn) {
        var remaining = items.length - visibleCount;
        if (remaining <= 0) {
          btn.style.display = 'none';
        } else {
          btn.textContent = '+ ' + remaining + ' autres couleurs';
        }
      }
    }

    updateVisibility();

    if (btn) {
      btn.addEventListener('click', function () {
        visibleCount += LOAD_MORE_COUNT;
        updateVisibility();
      });
    }
  });
});
